/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import urlHelper from "../../../_helpers/url.format.server.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import SalesRep from "./OrderDetailsComponents/SalesRep";
import CourseInformation from "./OrderDetailsComponents/CourseInformation";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import {InstructorComponent} from "./OrderDetailsComponents/InstructorComponenent";
import SchoolChangeModal from "./OrderDetailsComponents/InstitutionChangeComponent/SchoolChangeModal";
import {find} from "lodash";
import DeskCopy from "./OrderDetailsComponents/DeskCopy";
import PropTypes from "prop-types";
import moment from 'moment';
import {PERMISSIONS} from "../../constants/constants";


export default class OrderDetails extends Component {

    static get propTypes() {
        return {
            collection: PropTypes.object.isRequired,
            bookBuildDetails: PropTypes.object.isRequired,
            loadInitialData: PropTypes.func.isRequired,
            updateCollection: PropTypes.func.isRequired,
            updateBookBuildDetails: PropTypes.func.isRequired,
            guardDirtySetActive: PropTypes.func.isRequired,
            guardDirtyIsActive: PropTypes.bool.isRequired,
            setComponent: PropTypes.func.isRequired,
            loadBookBuildDetails: PropTypes.object.isRequired
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            contactInfo: {},
            schoolInfo: {},
            salesForceOrg: [],
            creator: {},
            instructorObj: {},
            searchedSchools:[],
            showInstructorModal: false,
            showInstituteModal: false,
            searchedCode: ''
        };
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("OrderDetails");
        }
        this.getContactInfoByCollectionId(this.props.match.params.collId)
            .then(response => {
                this.setState({
                    contactInfo: response.data
                });
            });
        this.getSalesForceOrgs()
            .then(response => {
                this.setState({
                    salesForceOrg: response.data
                });
            });
        this.getUser(this.props.collection.creator)
            .then(response => {
                this.setState({
                    creator: response.data
                });
            });
        this.props.guardDirtySetActive(false);

        this.getSchoolInfoBySchoolId(this.props.bookBuildDetails.institution ? this.props.bookBuildDetails.institution : '')
            .then(response => {
                this.setState({
                    schoolInfo: response.data
                });
            });
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.collection.collectionId !== this.props.collection.collectionId) {
            this.getUser(nextProps.collection.creator)
                .then(response => {
                    this.setState({
                        creator: response.data
                    });
                });
        }
        if (nextProps.bookBuildDetails.institution && nextProps.bookBuildDetails.institution !== this.props.bookBuildDetails.institution) {
            this.getSchoolInfoBySchoolId(nextProps.bookBuildDetails.institution ? nextProps.bookBuildDetails.institution : '')
                .then(response => {
                    this.setState({
                        schoolInfo: response.data
                    });
                });
        }
    }

    getContactInfoByCollectionId = (collectionId) => {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.contactInfo,
            {collectionId: collectionId});
        return AxiosClient.get(url);
    };

    getSchoolInfoBySchoolId = (schoolId) => {
        const url = urlHelper.formatUrl(
            config.oneCRMService.baseUrl,
            config.oneCRMService.routes.getSchoolInfoBySchoolId,
            {schoolId: schoolId});
        return AxiosClient.get(url);
    };

    getSalesForceOrgs = () => {
        const url = urlHelper.formatUrl(
            config.oneCRMService.baseUrl,
            config.oneCRMService.routes.getSalesForceOrgCodes);

        return AxiosClient.get(url);
    };

    getUser = (creatorId) => {
        const url = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.getUserById,
            {userId: creatorId});

        return AxiosClient.get(url);
    };

    showInstructorModal = (visibility) => {
        this.setState({
            showInstructorModal : visibility
        });
    };

    showInstituteModal = (visibility) => {
        this.setState({
            showInstituteModal : visibility
        });
    };

    saveInstructorCourseContact = () => {
        this.showInstructorModal(false);
        const params = this.state.instructorObj;
        const options = {
            instructor: !params ? null : {...params},
            institution: null
        };
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.contactInfo,
            {collectionId: this.props.collection.collectionId});

        AxiosClient.patch(url, options)
            .then(() => {
                this.getContactInfoByCollectionId(this.props.collection.collectionId)
                    .then(response => {
                        this.setState({
                            contactInfo: response.data
                        });
                    });
                this.props.loadBookBuildDetails(this.props.collection.collectionId);
            })
            .catch(error => {
                console.log('error:', error);
            });
    };

    getInsObject = (insObj) => {
        this.setState({
            instructorObj: insObj
        });
    };

    searchInstructorInfo = (contactType, options) => {
        
        const UrlObj = [this.searchInfo(contactType, options), this.searchUserInfo(contactType, options)];
        return Promise.all(UrlObj);
      
    };


    searchInfo = (contactType, options) => {
        
        let ServiceUrlForInstructors;
        
        if (contactType === 'Instructor') {
            ServiceUrlForInstructors = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.getInstructorsBySearchTerm,
                {
                    queryParams: {
                        "searchTerm": options.searchTerm,
                        "geoId": options.geoId,
                        "unscrubbed": options.unscrubbed
                    }
                });
                        
        } else {
            ServiceUrlForInstructors = urlHelper.formatUrl(
                config.identity.baseUrl,
                config.identity.routes.getInstructorsBySearchTerm,
                {
                    queryParams: {
                        "userRole": contactType,
                        "searchTerm": options.searchTerm
                    }
                });
        }
        
        return AxiosClient.get(ServiceUrlForInstructors);
    };

    searchUserInfo = (contactType, options) => {
        let ServiceUrlForUsers;
        
        
        if (contactType === 'Instructor') {
            
            ServiceUrlForUsers = urlHelper.formatUrl(
                config.identity.baseUrl,
                config.identity.routes.getUsersBySearchTerm,
                {
                    queryParams: {
                        "userRole": contactType,
                        "searchTerm": options.searchTerm,
                        "geoId": options.geoId,
                        "unscrubbed": options.unscrubbed
                    }
                });
            
            
        }
        
        return AxiosClient.get(ServiceUrlForUsers);
    };

    searchSchoolsByPostalCode = (countryCode, postalCode, isNccerCollection) => {
        let options = {
            isNccerCollection: false
        };

        if (this.props.bookBuildDetails && this.props.bookBuildDetails.school === 'NCCER') {
            options.isNccerCollection = true;
        }
        const url = urlHelper.formatUrl(
            config.oneCRMService.baseUrl,
            config.oneCRMService.routes.searchSchoolsByPostalCode,
            {
                queryParams: {
                    "postalcode": postalCode,
                    "countrycode": countryCode,
                    "isNccerCollection":isNccerCollection
                }
            });
        return AxiosClient.get(url, options)
            .then(response => {
                const nccerSchool = {
                    schoolId: 2206294876,
                    schoolName: 'NCCER',
                    territory: {
                        territoryId: '8702'
                    }
                };
                if (countryCode === 'USA') {
                    if (options.isNccerCollection === true) {
                        //set nccer-institute as top item on the list for US NCCER collections
                        response.data.unshift(nccerSchool);
                    } else {
                        //set nccer-institute as the bottom item on the list for non-NCCER US collections
                        response.data.push(nccerSchool);
                    }
                }
                //response.data.push(nccerSchool);
                this.setState({
                    searchedSchools: response.data
                });
                return response;
            })
            .catch(error => {
                console.log(error);
            });

    };

    saveSelectedSchool = () => {
        this.showInstituteModal(false);
        const selectedSchoolInfo = this.state.selectedSchoolInfo;

        const institutionToBeStored = {'institution': selectedSchoolInfo.schoolId, 'institutionZip': this.state.searchedCode, 'territory': null};

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.instituteInfo,
            {
                collectionId: this.props.collection.collectionId
            });

        AxiosClient.patch(url, institutionToBeStored)
            .then(response => {
                this.props.loadInitialData(this.props.collection.collectionId);
            })
            .catch(error => {
                console.log('error:', error);
            });
    };

    getSelectedSchool = (schoolId) => {
        const selectedSchoolInfo = find(this.state.searchedSchools, function (s) {
            return s.schoolId === schoolId;
        });
        this.setState({selectedSchoolInfo});
    };

    getSearchedPostalCode = (code) => {
        this.setState({
            searchedCode : code
        });
    };

    enableSubmit = (enable) => {
        this.props.guardDirtySetActive(enable);
    };

    updateCourseInfoState = (field,value) => {
        let collectionCourseInformation = this.props.collection.collectionCourseInformation ? this.props.collection.collectionCourseInformation : {};
        collectionCourseInformation[field] = value;
        this.props.updateCollection('collectionCourseInformation', collectionCourseInformation);
    };

    handleInputUpdates = (type, payload) => {
        switch (type) {
            case "courseName": {
                this.updateCourseInfoState('courseTitle',payload);
                break;
            }
            case "courseNumber": {
                this.updateCourseInfoState('courseNo',payload);
                break;
            }
            case "estimatedEnrollments": {
                this.updateCourseInfoState('estimatedQty',payload);
                break;

            }
            case "courseStart": {
                this.updateCourseInfoState('classStart',payload);
                break;
            }
            case "term": {
                this.props.updateBookBuildDetails('schoolTerm',payload);
                break;
            }
            default: {
                break ;
            }
        }
    };

    handleSelectOnChange = (event) => {
        this.props.updateBookBuildDetails('salesForceOrg',event.target.value);
        this.props.guardDirtySetActive(true);
    };

    render() {
        const ShowcontactInfo = !!this.state.contactInfo;
        const {collectionCourseInformation} = this.props.collection;
        const {permissions, collection}=this.props;
        return (
            <div className="pe-row order-details-container">
                <div className="order-details-page">
                    <div className="order-details">
                        <div className='pe-row'>
                            <div className="pe-col-12">
                                <div className='header-margin'>
                                    <label className="pe-title--small">Order Details</label>
                                </div>
                            </div>
                        </div>
                        <div className='pe-row'>
                            <div className="pe-col-6">
                                <div className="pe-row">
                                    <div className="pe-col-3">
                                        <label className="pe-label--bold">Status</label>
                                    </div>
                                    <div className="pe-col-6">
                                        <label className="pe-label">{this.props.collection.status}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='pe-row'>
                            <div className="pe-col-6">
                                <div className="pe-row order-info">
                                    <div className="pe-col-3">
                                        <label className="pe-label--bold">Submitted</label>
                                    </div>
                                    <div className="pe-col-6">
                                        <label
                                            className="pe-label">{moment.utc(this.props.collection.publishDate).format('YYYY-MM-DD')}</label>
                                    </div>
                                </div>
                                <div className="pe-row order-info creator">
                                    <div className="pe-col-3">
                                        <label className="pe-label--bold">Creator</label><br/>
                                    </div>
                                    <div className="pe-col-6">
                                        <label
                                            className="pe-label">{this.state.creator.id ? (this.state.creator.firstName + ' ' + this.state.creator.lastName
                                            + (this.state.creator.id ? this.state.creator.username ? ' | ' + this.state.creator.username : '' : ' | No Account')) : ''}</label><br/>
                                        {this.state.contactInfo.instructor
                                        && <a href={"mailto:" + (this.state.creator.email ? this.state.creator.email : '')}> {this.state.creator.email ? this.state.creator.email : ''}</a>}
                                    </div>
                                </div>
                                <div className="pe-row order-info instructor">
                                    <div className="pe-col-3">
                                        <label className="pe-label--bold">Instructor</label><br/>
                                        {ShowcontactInfo && !this.props.permissions.includes(PERMISSIONS.view_only_instructor_change) && <a onClick={()=>{this.showInstructorModal(true);}} className="change-link">Change</a>}
                                    </div>
                                    <div className="pe-col-6">
                                        <label
                                            className="pe-label">{this.state.contactInfo.instructor ? (this.state.contactInfo.instructor.firstName + ' ' + this.state.contactInfo.instructor.lastName
                                            + (this.state.contactInfo.instructor.id ? this.state.contactInfo.instructor.username ? ' | ' + this.state.contactInfo.instructor.username : '' : ' | No Account')) : ''}</label><br/>
                                        {this.state.contactInfo.instructor
                                        && <a href={"mailto:" + (this.state.contactInfo.instructor.email ? this.state.contactInfo.instructor.email : '')}> {this.state.contactInfo.instructor.email ? this.state.contactInfo.instructor.email : ''}</a>}
                                    </div>
                                </div>
                                <div className="pe-row order-info institution">
                                    <div className="pe-col-3">
                                        <label className="pe-label--bold">Institution</label><br/>
                                        {!this.props.permissions.includes(PERMISSIONS.view_only_institution_change) && <a onClick={()=>{this.showInstituteModal(true);}} className="change-link">Change</a> }
                                    </div>
                                    <div className="pe-col-6">
                                        <label
                                            className="pe-label">{this.props.bookBuildDetails.school && this.props.bookBuildDetails.school}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="sales-rep">
                                <div className="pe-col-3">
                                    <SalesRep options={
                                        {
                                            salesRepName: this.state.contactInfo.salesRepresentative && this.state.contactInfo.salesRepresentative ? (this.state.contactInfo.salesRepresentative.firstName + ' ' + this.state.contactInfo.salesRepresentative.lastName) : '',
                                            salesRepEmail: this.state.contactInfo.salesRepresentative && this.state.contactInfo.salesRepresentative ? this.state.contactInfo.salesRepresentative.email : '',
                                            salesRepTerr: this.state.schoolInfo.territory && this.state.schoolInfo.territory.territoryName,
                                            salesRepArea: this.state.schoolInfo.city
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className='pe-row new-row'>
                            <div className="pe-col-6">
                                <div className="pe-row course-info">
                                    <div className="pe-col-3 org-unit">
                                        <label className="pe-title--secondary" htmlFor="orgCodes">Org Unit</label>
                                        <div className="pe-select-container">
                                            <select className="pe-selectInput--basic" id="orgCodes"
                                                onChange={this.handleSelectOnChange} disabled={this.props.permissions.includes(PERMISSIONS.view_only_org_unit)}>
                                                {this.state.salesForceOrg.map((entity, i) => {
                                                    if (entity.salesForceOrgId === this.props.bookBuildDetails.salesForceOrg) {
                                                        return <option selected key={i}
                                                            value={entity.salesForceOrgId}> {entity.salesForceName} </option>;
                                                    } else {
                                                        return <option key={i}
                                                            value={entity.salesForceOrgId}> {entity.salesForceName} </option>;
                                                    }
                                                })
                                                }
                                            </select>
                                            <svg aria-hidden="true"
                                                focusable="false"
                                                className="pe-icon--dropdown-open-18">
                                                <use xlinkHref="#dropdown-open-sm-18"></use>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="course-info">
                                    <CourseInformation options={{
                                        courseName: collectionCourseInformation ? collectionCourseInformation.courseTitle : '',
                                        courseNumber: collectionCourseInformation ? collectionCourseInformation.courseNo : '',
                                        courseStartDate: collectionCourseInformation ? collectionCourseInformation.classStart : null,
                                        schoolTerm: this.props.bookBuildDetails.schoolTerm ? this.props.bookBuildDetails.schoolTerm : '',
                                        updateInputs: this.handleInputUpdates,
                                        enableSubmit: this.enableSubmit,
                                        courseId: collectionCourseInformation ? collectionCourseInformation.courseId ? collectionCourseInformation.courseId : '' : '',
                                        permissions:permissions
                                    }}/>
                                </div>
                            </div>
                            <div className="pe-col-6">
                                <div className="pe-row">
                                    <label className="pe-col-6 pe-label--bold">Comments from creator</label>
                                </div>
                                <div className="pe-row">
                                    <div className="pe-col-10 comments commentbox">
                                        <textarea
                                            className="pe-multiLineText comments"
                                            id="nope"
                                            cols="30"
                                            rows="5"
                                            disabled
                                            value={collectionCourseInformation ? collectionCourseInformation.contactPearsonSupport : ''}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="desk-copy-container">
                        <DeskCopy
                            deskCopies={this.props.options.deskCopies}
                            updateDeskCopy={this.props.options.updateDeskCopy}
                            geoCode={this.props.collection.geo ? this.props.collection.geo.code : 'US'}
                            bookBuild={this.props.bookBuildDetails}
                            updateBookBuildDetails={this.props.updateBookBuildDetails}
                            enableSubmit={this.enableSubmit}
                            permissions={this.props.permissions}
                        />
                    </div>
                </div>
                <ModalDialog
                    showModal={this.state.showInstructorModal}
                    onSuccess={this.saveInstructorCourseContact}
                    onCancel={() => {this.showInstructorModal(false);}}
                    title="Change Instructor"
                >
                    <InstructorComponent
                        getInsObject={this.getInsObject}
                        activeCollection={collection}
                        contactInfo={this.state.contactInfo ? this.state.contactInfo : null}
                        searchInstructorInfo={this.searchInstructorInfo}
                    />
                </ModalDialog>
                <ModalDialog
                    showModal={this.state.showInstituteModal}
                    onSuccess={this.saveSelectedSchool}
                    onCancel={() => {this.showInstituteModal(false);}}
                    title="Change Institute"
                >
                    <SchoolChangeModal
                        activeCollection={this.props.collection}
                        currentUserGeo={this.props.collection.geo ? this.props.collection.geo.code : 'US'}
                        schoolsList={this.state.searchedSchools}
                        searchSchoolByPostalCode={this.searchSchoolsByPostalCode}
                        getSelectedSchool={this.getSelectedSchool}
                        getSearchedPostalCode={this.getSearchedPostalCode}
                    />
                </ModalDialog>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetails.js